import React, { useEffect, useState } from 'react';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { ReactSession } from 'react-client-session';
import DiscoutRange from './discount-range';
import VideoPage from '../videoModal/VideoPage';

const FilterPannerComponent = forwardRef((props, ref) => {

    const refDiscoutRange = useRef(null);
    const [projecttoggleshow, setProjectToggleShow] = useState(true)
    const [selectBR, setSelectBR] = useState([]);
    const [selectBArea, setSelectBArea] = useState([]);
    const [selectFloorFilter, setSelectFloorFilter] = useState([]);
    const [startPrice, setSstartPrice] = useState(0);
    const [endPrice, setEndPrice] = useState(0);
    const [minValue, set_minValue] = useState(localStorage.getItem('minValue') || startPrice);
    const [maxValue, set_maxValue] = useState(localStorage.getItem('maxValue') || endPrice);
    const [selectBRType, setSelectBRType] = useState([]);
    const [selectedAreaType, setSelectedAreaType] = useState('');
    const [floorArray, setFloorArray] = useState([]);
    var stringTempData = ""
    var [filteredValue, setFiteredValue] = useState({});
    const [roomTypeFloor, setRoomTypeFloor] = useState(false);
    const [noOfUnits, setNoOfUnits] = useState('');
    const [tyoeOfBed, setTyoeOfBed] = useState([]);
    const [tyoeFloor, setTyoeFloor] = useState([]);
    const [tyoeOfBedSub, setTyoeOfBedSub] = useState([]);
    const [priceRangeArr, setPriceRangeArr] = useState([])
    const [videosModalShow, setVideosModalShow] = useState(false);
    const refStartPriceInput = useRef(null);
    const refEndPriceInput = useRef(null);
    const [showAllActive, setShowAllActive] = useState(false);
    const [hideAllActive, setHideAllActive] = useState(false);
    const [currentVideo, setCurrentVideo] = useState('');


    const [minArea, setMinArea] = useState(80);
    const [maxArea, setMaxValue] = useState(323);
    const handleInputArea = (e) => {
        setMinArea(e.minValue);
        setMaxValue(e.maxValue);
    };

    const onclickShow = () => {
        props.floorplanhandlehandleShow();
        setShowAllActive(true); // Set the button as active
        setHideAllActive(false); // Set the other button as inactive
        props.setFilterPannel(true)
    }
    const onClikcHide = () => {
        setShowAllActive(false); // Set the button as inactive
        setHideAllActive(true); // Set the other button as active
        onClick3DLayout()
        props.setFilterPannel(true)
        showVideo()
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    const showVideo = () => setVideosModalShow(true);
    const hideVideo = () => setVideosModalShow(false);
    useImperativeHandle(ref, () => ({
        setPriceRange: (min, max) => {
            /*Update Discount range price*/
            setSstartPrice(min)
            setEndPrice(max)
            set_minValue(min)
            set_maxValue(max)
            setPriceRangeArr([min, max])
            /*Update Discount range price*/

        },
        setAvailableUnits: (val) => {
            setNoOfUnits(String(val))
        },
        reSetTyoeOfBed: (val) => {
            setTyoeOfBed(val)
        },
        reSetFloorFilter: (val) => {
            val.sort(function (a, b) {
                return Number(a) - Number(b);
            });
            setTyoeFloor(val)
        },
        reSetTyoeOfBedSub: (val) => {
            val.sort(function (a, b) {
                return Number(a) - Number(b);
            });
            setTyoeOfBedSub(val)
        },
        setRoomType: (type) => {
            setRoomTypeFloor(type)
        },
        storeFilter: () => {
            ReactSession.set("filter", filteredValue)
        },
        resetAll: () => {
            onReset(true)
        },
        getFilter: (isThatBlock) => {
            return reloadFilter(isThatBlock)
        }
    }));
    useEffect(() => {
        svgLoad()
        console.log(noOfUnits, "NoOfUnits")
    }, [noOfUnits])
    const handleRangeClick = (e) => {
        set_minValue(e.minValue);
        set_maxValue(e.maxValue);
    };
    const reloadFilter = (isThatBlock) => {
        var filter = ReactSession.get("filter")
        filteredValue = {}
        if (isThatBlock === true && false) {
            if (filter["TB"] != undefined && filter["TB"] != null) {
                if (isNaN(filter["TB"]) === true) {
                    delete filter["TB"]
                }
            }
        } else {
            if (isNaN(filter["TB"]) === false) {
                delete filter["TB"]
            }
        }
        if (Object.keys(filteredValue).length === 0 && Object.keys(filter).length != 0) {
            Object.keys(filter).map((data, index) => {
                Object.keys(filter[data]).map((data1, index) => {
                    switch (data) {
                        case "AB":
                            return setSelectBArea(filter[data]);
                        case "NB":
                            return setSelectBR(filter[data]);
                        case "TB":
                            return setSelectBRType(filter[data]);
                    }
                })
                if (data === "R") {
                    var m1 = parseInt(filter[data].split("-")[0])
                    var m2 = parseInt(filter[data].split("-")[1])
                    setPriceRangeArr([m1, m2])
                    return
                }
            })

        }
        setFiteredValue(filter)
        return filter
    }

    const svgLoad = () => {
        // const objTag = document.querySelector('object')
        // objTag.addEventListener('load', () => {
        const obj = document.getElementById("resetControl")
        if (obj !== null) {
            obj.setAttribute("visibility", "hide");
            // obj.addEventListener('click', onReset);
        }
        // })
    }
    useEffect(() => {
        svgLoad();
    }, [/* dependencies */]);
    const onReset = (singleton) => {
        if (props.resetSelectedItem !== undefined) {
            props.resetSelectedItem();
        }
        // refDiscoutRange.current.state.values = [startPrice, endPrice];
        setFiteredValue({});
        setSelectBR([]);
        setSelectBArea([]);
        setSelectBRType([]);
        setSelectFloorFilter([]);
        set_minValue(startPrice);
        set_maxValue(endPrice);
        setPriceRangeArr([startPrice, endPrice]);
        localStorage.removeItem('minValue'); // Remove from local storage
        localStorage.removeItem('maxValue'); // Remove from local storage
        applyFilter(singleton);
    }
    const callArea = (nb) => {
        if (selectBArea.includes(nb)) {
            selectBArea.splice(selectBArea.indexOf(nb), 1);
        } else {
            selectBArea.push(nb)
        }
        filteredValue["AB"] = selectBArea
        setSelectBArea(selectBArea)

        applyFilter()
    }
    /*update input field*/
    const filterPrice = (start, end) => {
        set_minValue(start);
        set_maxValue(end);
        // refStartPriceInput.current.value = start;
        // refEndPriceInput.current.value = end;
        if (start >= end) {
            setSstartPrice(start)
        }
        const price = start + "-" + end
        filterValueR(price)
    }
    /*update input field*/

    /*apply filter on svg*/
    const filterValueR = (price) => {
        filteredValue["R"] = price
        applyFilter()
    }
    /*apply filter on svg*/

    const callSelBR = (nb) => {
        if (selectBR.includes(nb)) {
            selectBR.splice(selectBR.indexOf(nb), 1);
        } else {
            selectBR.push(nb)
        }
        filteredValue["NB"] = selectBR
        setSelectBR(selectBR)
        if (roomTypeFloor === false && selectBR.length === 0) {
            setSelectBRType([])
            delete filteredValue["TB"]
        }
        applyFilter()
        props.selectNBComponent(nb)
    }
    const callTypeOfBedRoom = (nb) => {
        var tmp = selectBRType
        if (tmp.includes(nb)) {
            tmp.splice(tmp.indexOf(nb), 1);
        } else {
            tmp.push(nb)
        }
        setSelectBRType(tmp)
        filteredValue["TB"] = tmp
        applyFilter()
    }
    const callFloorFilter = (nb) => {
        var tmp = selectFloorFilter
        if (tmp.includes(nb)) {
            tmp.splice(tmp.indexOf(nb), 1);
        } else {
            tmp.push(nb)
        }
        setSelectFloorFilter(tmp)
        filteredValue["F"] = tmp
        applyFilter()
    }

    const applyFilter = (singleton) => {
        setNoOfUnits('')
        if (singleton != true) {
            ReactSession.set("filter", filteredValue)
        }
        setTimeout(function () {
            props.updateSvgForBlockSelection(filteredValue)
        }, 200);
    }

    const sleep = ms => new Promise(
        resolve => setTimeout(resolve, ms)
    );
    function checkIsSubtype(e) {
        var uniqueTags = []
        if (tyoeOfBed.length > 0) {
            tyoeOfBed.map((row, index) => {
                if (selectBR.includes(row)) {
                    e.map((row1, index1) => {
                        if (row[0] === row1[0]) {
                            if (uniqueTags.includes(row1) === false) {
                                uniqueTags.push(row1)
                            }

                        }
                    })
                }
            })
        }
        return uniqueTags
    }
    const onClickBoxOpen = () => {
        props.filterPannel ? props.setFilterPannel(false) : props.setFilterPannel(true)
    }
    const onClickHide = () => {
        props.setListOfImages(false)
    }

    const handleMinInputChange = (event) => {
        const newMinValue = parseFloat(event.target.value);
        if (!isNaN(newMinValue) && newMinValue < maxValue) {
            set_minValue(newMinValue);
            localStorage.setItem('minValue', newMinValue); // Save to local storage
            if (refDiscoutRange.current) {
                refDiscoutRange.current.updateValues([newMinValue, maxValue]);
            }
        }
    };

    const handleMaxInputChange = (event) => {
        const newMaxValue = parseFloat(event.target.value);
        if (!isNaN(newMaxValue) && newMaxValue >= minValue) {
            set_maxValue(newMaxValue);
            localStorage.setItem('maxValue', newMaxValue); // Save to local storage
            if (refDiscoutRange.current) {
                refDiscoutRange.current.updateValues([minValue, newMaxValue]);
            }
        }
    };
    const handleVideoChange = (newVideo) => {
        setCurrentVideo(newVideo)
    };
    const onClick3DLayout = () => {
        const isiPhone = /iPhone/i.test(navigator.userAgent);

        if (isiPhone) {
            // Redirect iPhone users to the YouTube app using the currentVideo state
            redirectToYouTubeApp(currentVideo);
        } else {
            // Handle other devices as needed (e.g., open a modal)
            setVideosModalShow(true);
        }
    };
    const redirectToYouTubeApp = (videoUrl) => {
        const videoId = extractYouTubeVideoId(videoUrl);

        if (videoId) {
            // Redirect iPhone users to the YouTube app
            window.location.href = `youtube://watch?v=${videoId}`;
        } else {
            // Handle the case where the video ID cannot be extracted
            console.error("Unable to extract YouTube video ID");
        }
    };
    // Function to extract YouTube video ID from the link
    const extractYouTubeVideoId = (url) => {
        const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
        return match && match[1];
    };
    useEffect(() => {
        // Redirect to YouTube app when currentVideo state is updated
        const isiPhone = /iPhone/i.test(navigator.userAgent);
        if (currentVideo && isiPhone) {
            redirectToYouTubeApp(currentVideo);
        }
    }, [currentVideo]);
    useEffect(() => {
        const savedMinValue = localStorage.getItem('minValue');
        const savedMaxValue = localStorage.getItem('maxValue');
        if (savedMinValue !== null && savedMaxValue !== null) {
            // Values exist in local storage, use them
            set_minValue(parseFloat(savedMinValue));
            set_maxValue(parseFloat(savedMaxValue));
        }
    }, []);
    return (
        <>
            <div className={!props.filterPannel ? 'FilterPannel' : ' FilterPannel1'}>
                <div className='filterPannelData'>
                    <div>
                        <div className='arrowBtn' onClick={onClickBoxOpen}>
                            {
                                !props.filterPannel ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="#fff" className="bi bi-arrow-right-square-fill" viewBox="0 0 16 16">
                                        <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1z" />
                                    </svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="#fff" className="bi bi-arrow-left-square-fill" viewBox="0 0 16 16">
                                        <path d="M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1z" />
                                    </svg>
                            }
                        </div>
                        <div className='blockSelectionBox'>
                            {props.floorplanNetArea > 0 && props.floorplanApId.length > 0 && props.listOfImages ?
                                <>
                                    <div className={!props.filterPannel ? 'tableData' : "tableData1"} >
                                        <img onClick={onClickHide} style={{ cursor: "pointer", marginTop: "6px", marginLeft: "-6px" }} src='/assets/images/closebutton.svg' />
                                        <div className='navigatorBoxItems'>
                                            <p className='text-center p-1' style={{ marginBottom: "0", borderBottom: "2px solid #DC6641", marginBottom: '10px', paddingBottom: "0", fontWeight: "600" }}>Unit - {props.floorplanApId} </p>
                                            <p>Layout Type: {props.floorplanLayout.trim()} </p>
                                            <p >Floor: {props.floorplanFloor}</p>
                                            <p>Gross Area: {props.floorplanNetArea}</p>
                                            <p>Price: {props.floorplanPrice}</p>
                                        </div>
                                        <div className='text-center'>
                                            <img src={"assets/images/floor_plate/" + props.floorplanKeyPlan + ".jpg"} />
                                        </div>
                                        <div className='floor3DBtn'>
                                            <button onClick={onclickShow}
                                                className={`floorplanButton ${showAllActive ? 'active-button' : ''}`} >Floor Plan</button>
                                            <button variant="primary" onClick={onClikcHide} className={`floorplanButton ${hideAllActive ? 'active-button' : ''}`} >3D Layout</button>
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    <div className={!props.filterPannel ? 'filterPannelItems' : "filterPannelItems1"}>
                                        <h3>Navigator</h3>
                                        <div className='filterPannelSidebar'>
                                            <div>
                                                <div className='bedroomData'>
                                                    <h6>Select Bedroom</h6>
                                                    <ul className='bedroomItems'>
                                                        {
                                                            tyoeOfBed.length > 0 && tyoeOfBed.map((row, index) => {
                                                                let bId = "new_bedid_" + row;
                                                                return (
                                                                    <>
                                                                        {
                                                                            <li className={selectBR.includes(row) ? `newBox ${bId} active ` : `newBox  ${bId}`} onClick={() => { callSelBR(row); }} ><a >{row[0] + 'BR'}</a></li>

                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                                {
                                                    !props.imageHidden ? <div className='floorData'>
                                                        <h6>Select Floor</h6>
                                                        <div className=''>
                                                            <ul className='floorItems'>
                                                                {

                                                                    tyoeFloor.length > 0 && tyoeFloor.map((row, index) => {
                                                                        return (
                                                                            <>
                                                                                <small className={selectFloorFilter.includes(row) ? 'newBox active' : 'newBox'} onClick={() => callFloorFilter(row)}>{row}</small>
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div> : ""
                                                }
                                                <div className='areaData'>
                                                    <h6>Select Area</h6>
                                                    <div className='areaItems'>
                                                        {
                                                            props.buildUpArea != undefined && props.buildUpArea.length > 0 && props.buildUpArea.map((row, index) => {
                                                                return (
                                                                    <>
                                                                        {
                                                                            <small className={selectBArea.includes(row) ? 'newBox active' : 'newBox'} onClick={() => callArea(row)}>{row}Sqm</small>
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <div className="priceData">
                                                    <h6>Filter By Price ($)</h6>
                                                    {/* DiscoutRange component */}
                                                    {/* <div className='price_input_field'>
                                                        <div style={{ textAlign: "start" }}>
                                                            <input
                                                                type="number"
                                                                value={minValue}
                                                                onChange={handleMinInputChange}
                                                                ref={refStartPriceInput} // Attach the ref here
                                                            />
                                                        </div>
                                                        <div style={{ textAlign: "end" }}>
                                                            <input
                                                                type="number"
                                                                value={maxValue}
                                                                onChange={handleMaxInputChange}
                                                                ref={refEndPriceInput} // Attach the ref here
                                                            />
                                                        </div>
                                                    </div> */}
                                                    {startPrice < endPrice ?
                                                        <DiscoutRange ref={refDiscoutRange} name={"test"} MIN={startPrice} range={priceRangeArr} MAX={endPrice}
                                                            onChange={(values) => {
                                                                if (values[0] < endPrice) {
                                                                    filterPrice(values[0], values[1])
                                                                }
                                                            }
                                                            }
                                                        />
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                            <div className='availableUnit'>
                                                <div className="abailityApartment">
                                                    <h6 className='text-center'>Available Units {noOfUnits} </h6>
                                                </div>
                                                <div className='resetSvg ' onClick={onReset} >
                                                    <p>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                                            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                                        </svg>
                                                        Reset</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>

                </div>
            </div>
            {videosModalShow ?
                <VideoPage cubedotsId={props.floorplanApId} show={true} onHide={hideVideo}
                    filterPannel={props.filterPannel}
                    setFilterPannel={props.setFilterPannel}
                    onVideoChange={handleVideoChange}
                />
                : null}

        </>
    )
})
export default FilterPannerComponent;